<template>
  <section id="dashboard">
    <div class="mb-4 card">
      <div class="d-sm-flex justify-content-between p-2 pb-3">
        <h4 class="mb-sm-0 pt-2">
          <a href="/dashboard">Home Page</a><span>/</span><span>Dashboard</span>
        </h4>
      </div>
    </div>
    <section class="mt-lg-5">
      <mdb-row>
        <mdb-col md="4" class="mb-r">
          <mdb-card
            cascade
            class="cascading-admin-card classic-admin-card bg-dark white-text"
          >
            <div class="admin-up">
              <mdb-icon icon="user-graduate" fas class="bg-dark" />
              <div class="data py-3">
                <h4 class="white-text font-weight-bold">Total Students</h4>
                <h4 class="">
                  <strong class="white-text pr-2">{{ totalStudents }}</strong>
                </h4>
              </div>
            </div>
            <mdb-card-body>
              <router-link to="/students" @click.native="activeItem = 4">
                <button class="btn btn-outline-white btn-block btn-sm">
                  View Students
                </button>
              </router-link>
            </mdb-card-body>
          </mdb-card>
        </mdb-col>

        <mdb-col md="4" class="mb-r">
          <mdb-card
            cascade
            class="cascading-admin-card classic-admin-card bg-dark white-text"
          >
            <div class="admin-up">
              <mdb-icon icon="user-graduate" fas class="bg-dark" />
              <div class="data py-3">
                <h4 class="white-text font-weight-bold">Pending Students</h4>
                <h4 class="">
                  <strong class="white-text pr-2">{{ pendingStudents }}</strong>
                </h4>
              </div>
            </div>
            <mdb-card-body>
              <router-link to="/pending-students" @click.native="activeItem = 4">
                <button class="btn btn-outline-white btn-block btn-sm">
                  View Pending Students
                </button>
              </router-link>
            </mdb-card-body>
          </mdb-card>
        </mdb-col>

        <mdb-col md="4" class="mb-r">
          <mdb-card
            cascade
            class="cascading-admin-card classic-admin-card bg-dark white-text"
          >
            <div class="admin-up">
              <mdb-icon icon="file-alt" fas class="bg-dark" />
              <div class="data py-3">
                <h4 class="white-text font-weight-bold">Reports</h4>
              </div>
            </div>
            <mdb-card-body>
              <router-link to="/students-report" @click.native="activeItem = 4">
                <button class="btn btn-outline-white btn-block btn-sm">
                  View Reports
                </button>
              </router-link>
            </mdb-card-body>
          </mdb-card>
        </mdb-col>
      </mdb-row>
    </section>
  </section>
</template>

<script>
import axios from "axios";
import { mdbRow, mdbCol, mdbCard, mdbCardBody, mdbIcon } from "mdbvue";

export default {
  name: "Dashboard",
  components: {
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardBody,
    mdbIcon,
  },
  data() {
    return {
      totalStudents: "",
      totalTeachers: "",
      totalLevels: "",
      pendingStudents: 0,
      fastAdminToken: localStorage.getItem("fastAdminToken"),
    };
  },

  mounted() {
    this.$toast.open({
      message: "Processing : Loading Dashboard Data Please Wait...",
      type: "info",
    });

    const config = {
      headers: {
        Authorization: "Bearer " + this.fastAdminToken,
        "Content-Type": "application/json",
      },
    };
    axios
      .get(this.$apiURI + "/account/students", config)
      .then((response) => {
        if (response.data.error) {
          this.$toast.open({
            message: "Error : " + response.data.message,
            type: "error",
          });
        } else {
          // eslint-disable-next-line no-console
          // console.log(response.data.data.teachers)
          let students = response.data.data.students;
          this.totalStudents = students.length;
          this.pendingStudents = students.filter((e) => e.status=='pending').length;

        }
      })
      .catch((error) => {
        this.$toast.open({
          message: "Error : " + error.response.data.message,
          type: "error",
        });
      });

    axios
      .get(this.$apiURI + "/account/teachers", config)
      .then((response) => {
        if (response.data.error) {
          this.$toast.open({
            message: "Error : " + response.data.message,
            type: "error",
          });
        } else {
          // eslint-disable-next-line no-console
          // console.log(response.data.data.teachers)
          let teachers = response.data.data.teachers;
          this.totalTeachers = teachers.length;
        }
      })
      .catch((error) => {
        this.$toast.open({
          message: "Error : " + error.response.data.message,
          type: "error",
        });
      });

    axios
      .get(this.$apiURI + "/levels", config)
      .then((response) => {
        if (response.data.error) {
          this.$toast.open({
            message: "Error : " + response.data.message,
            type: "error",
          });
        } else {
          // eslint-disable-next-line no-console
          // console.log(response.data.data.teachers)
          let levels = response.data.data.levels;
          this.totalLevels = levels.length;
        }
      })
      .catch((error) => {
        this.$toast.open({
          message: "Error : " + error.response.data.message,
          type: "error",
        });
      });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.cascading-admin-card {
  margin: 20px 0;
  background: #1c2331 !important;
}

.btn:hover {
  color: #fff;
}

.cascading-admin-card .admin-up {
  margin-left: 4%;
  margin-right: 4%;
  margin-top: -20px;
  background: #1c2331 !important;
}

.cascading-admin-card .admin-up .fas,
.cascading-admin-card .admin-up .far {
  box-shadow: 0 2px 9px 0 rgba(0, 0, 0, 0.2), 0 2px 13px 0 rgba(0, 0, 0, 0.19);
  padding: 1rem;
  font-size: 1rem;
  color: #fff;
  text-align: left;
  margin-right: 1rem;
  border-radius: 3px;
  background: #1c2331 !important;
}

.cascading-admin-card .admin-up .data {
  float: right;
  margin-top: 2rem;
  text-align: right;
}

.admin-up .data p {
  color: #999999;
  font-size: 12px;
}

.classic-admin-card .card-body {
  color: #fff;
  margin-bottom: 0;
  padding: 0.9rem;
}

.classic-admin-card .card-body p {
  font-size: 13px;
  opacity: 0.7;
  margin-bottom: 0;
}

.classic-admin-card .card-body h4 {
  margin-top: 10px;
}
</style>
